import { render, staticRenderFns } from "./SearchBlock.vue?vue&type=template&id=cfea0104&scoped=true&"
import script from "./SearchBlock.vue?vue&type=script&lang=js&"
export * from "./SearchBlock.vue?vue&type=script&lang=js&"
import style0 from "./SearchBlock.vue?vue&type=style&index=0&id=cfea0104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfea0104",
  null
  
)

export default component.exports